import React from 'react';
import { MDBInput } from 'mdbreact';
import ListadoProductosCombos from '../../componentes/pos/posBody/modalAtributos/ListadoProductosCombos';
import { NumericFormat } from 'react-number-format';
import { calcularEnvioFactura, obtenerTotalesPedido, toNumber } from '../../utils/totalesPedido';

const tipoCanal = (canal) => canal === "Facturación" ? "Tienda Física" : canal === "Tienda" ? "Página web" : canal === "Activacion" ? "Activaciones" : "App"

const VerPedidoDetalle = ({ pedidoSelect, baseUrlProductos, setPedidoSelect, baseUrlCursos, baseUrl }) => {

	const currencyFormat = (num) => {
		let convert = toNumber(num)
		return '$' + convert.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
	}
	const totalesPedido = obtenerTotalesPedido(pedidoSelect)

	console.log('pedidoSelect', pedidoSelect)

	return (
		<div className='row'>
			<React.Fragment>
				<div className="col-md-6 pedidoAdmin">

					{pedidoSelect.pedido.map((item, index) => {
						const validarCurso = item.tipo === "Curso"

						return (

							<React.Fragment key={index}>
								<div className="row">
									<div className="col-md-4">
										<div className="fotoPedido">
											<img src={validarCurso ? `${baseUrlCursos}${item.url_imagen[0].nombre_imagen}` : `${baseUrlProductos}${item.url_imagen[0].nombre_imagen}`} />
										</div>
									</div>
									<div className="col-md-8">
										<h5>(x{item.cantidad}) {item.nombre_producto}</h5>
										<p>
											<b>Categorías: </b>
											{item.categoria_producto.map(cat => {
												return (
													<span>{cat}, </span>
												)
											})}

											<br />
											<b>
												{item.precio_rebajado > 0 ?
													<div>
														<span>({currencyFormat(item.precio_rebajado)}) </span>
														<span> </span>
														<span className="tachado">
															({currencyFormat(item.precio_producto)})
														</span>
													</div>
													: item.precio_producto_desc_user > 0 ?
														<div>
															<span>({currencyFormat(item.precio_producto_desc_user)}) </span>
															<span className="tachado">
																({currencyFormat(item.precio_original)})
															</span> <br />
															<span>Descuento por Curso: {item.descuentouser}%</span>
														</div>
														:
														<span>({item.precio_producto}) </span>
												}
											</b>
											<b>Atributos:</b><br />
											{item.atributos.map((atri, i) => {
												if (item.combo === "true") {
													return (<ListadoProductosCombos item={atri} key={i} baseUrl={baseUrl} />)
												}

												return (
													<div key={i}>
														{atri.tipo === 'Colores' ?
															<div style={{ display: 'flex' }}>
																<span><b>- {atri.tipo}:</b></span>
																<div className='cuadroColor' style={{ backgroundColor: atri.color ? atri.color : atri.atributo.color }}></div><span>{atri.opcion}</span>
															</div>
															:
															<span>- <b>{atri.tipo}:</b> {atri.opcion}</span>
														}
													</div>
												)
											})}
											<span><b>Precio:</b> ${item.precio_producto}</span>
										</p>
									</div>
								</div>
								<hr />
							</React.Fragment>

						)
					})}

				</div>




				<div className="col-md-6">
					<br />
					<h5>Detalles:</h5>
					<p>
						<b>Id de Pedido: BLUE-{pedidoSelect.id}</b> <br />
						<b>Fecha y hora: </b>{pedidoSelect.fecha}<br />
						<b>Estado: </b>{pedidoSelect.estado}<br />
						<b>Cambiar Estado: </b><br />

						<select className="browser-default custom-select selectEstado"
							name="estado"
							value={pedidoSelect.estado}
							onChange={e => setPedidoSelect({ ...pedidoSelect, estado: e.target.value })}>
							<option value="Aprobado">Aprobado</option>
							<option value="Pendiente">Pendiente</option>
							<option value="Incompleto">Incompleto</option>
							<option value="Fallido">Fallido</option>
							<option value="Devolucion">Devolución</option>
						</select>


						{pedidoSelect.estado === 'Pendiente' || pedidoSelect.estado === 'Incompleto' || pedidoSelect.estado === 'Fallido' || pedidoSelect.estado === 'Devolucion' ?

							<div>
								<MDBInput label="Motivo de Modificación" outline
									value={pedidoSelect.datosPago.motivoCancel}
									onChange={e => { setPedidoSelect({ ...pedidoSelect, datosPago: { ...pedidoSelect.datosPago, motivoCancel: e.target.value } }) }}
								/>

								<b>Quien lo canceló: </b>{pedidoSelect.datosPago.userCancel}<br />
							</div>

							: null}


					</p>
					<hr />
					<h5>Datos de Pago:</h5>
					<p>
						<b>Canal: </b>{tipoCanal(pedidoSelect.canal)}<br />
							{pedidoSelect?.datosPago?.medio && (<><b>Medio: </b>{pedidoSelect.datosPago.medio}<br /></>)}
							<b>ID Stipe: </b>{pedidoSelect.id_stripe}<br />
							<b>Subtotal: </b>{currencyFormat(totalesPedido.subtotalBruto)}<br />
							<b>Taxes: </b>{currencyFormat(totalesPedido.taxes)}<br />

						{pedidoSelect.datosPago.cupon !== undefined && pedidoSelect.datosPago.cupon !== '' ?
							<div>
								<b>Cupón: </b>{pedidoSelect.datosPago.cupon}%<br />
								{pedidoSelect.canal === "Facturación" ?
								<>
									<b>Descuento Cupón: </b><NumericFormat value={totalesPedido.descuento} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} /><br />
								</>
								:null}
							</div>
							: null}
						{pedidoSelect.datosPago.mediosPagoPasarela ?
							<>
								<b>Tax: </b><NumericFormat value={pedidoSelect?.datosPago?.tax} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} />  < br />
								<b>Fee: </b><NumericFormat value={pedidoSelect?.datosPago?.fee} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} /> < br />
							</>
							:null}
							<b>Vendedor: </b>{pedidoSelect.datosPago.vendedor}<br />
							<b style={{fontSize: 25}}>Total: </b><span style={{fontSize: 25}}>{currencyFormat(totalesPedido.total)}</span><br />
					</p>
					<hr />
					<h5>Medios de Pago:</h5>
					{pedidoSelect.datosPago.mediosPagoPasarela ? pedidoSelect?.datosPago?.mediosPagoPasarela.map(item => (
						<>
							<h5 style={{fontWeight: 'bold'}}>{item.medioPagoNombre} </h5>
							{item.medioPagoNombre === 'Efectivo' ?
								<div className='mb-2'>
									<b>Recibido: </b><NumericFormat value={item.importe} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} /> < br />
									<b>Cambio: </b><NumericFormat value={pedidoSelect.datosPago.cambio} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} /> < br />
									<b>Total </b><NumericFormat value={item.importe - pedidoSelect.datosPago.cambio} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} /><br />
								</div>
								:
								<div className='mb-2'>
									<b>Tax: </b><NumericFormat value={item.interes} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} />  < br />
									<b>Fee: </b><NumericFormat value={item.tarifaPorcentaje} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} /> < br />
									<b>Total </b><NumericFormat value={item.importe + item.interes + item.tarifaPorcentaje} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} /><br />
								</div>
							}
						</>
					)): null
					}
					<hr />
					<h5>Cliente: </h5>
					<p>
						<b>Nombre: </b>{pedidoSelect.cliente.nombre}<br />
						<b>E-mail: </b>{pedidoSelect.cliente.email}<br />
						<b>Teléfono: </b>{pedidoSelect.cliente.tel}<br />
						{/* <b>Cédula/Nit: </b>{pedidoSelect.cliente.nit}<br/> */}
						<b>País: </b>{pedidoSelect.cliente.pais}<br />
						<b>Estado: </b>{pedidoSelect.cliente.estado}<br />
						<b>Ciudad: </b>{pedidoSelect.cliente.ciudad}<br />
						<b>Dirección: </b>{pedidoSelect.cliente.direccion}<br />
						<b>ZipCode: </b>{pedidoSelect.cliente.zip}<br />

					</p>
					<hr />
					{pedidoSelect.canal === "Tienda" || pedidoSelect.canal === "App" ?
						<div>
							<h5>Envio: </h5>
							<p>
								<b>Cargas de Envio: </b>{parseInt(pedidoSelect.datosPago.cargas)}<br />
								<b>Total Cargas de Envio: </b>{currencyFormat(calcularEnvioFactura(pedidoSelect))}<br />
							</p>
							<hr />
						</div>
					:null}

				</div>
			</React.Fragment>
		</div>
	)
}

export default VerPedidoDetalle
